module.exports = __webpack_public_path__ + "img/vindicologo.51a30d13.png";